/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ApiBase } from 'api/api'
import { makeGetRequest, makePostRequest } from 'api/fetchCalls'
import type { ReportQueryProps, ReportResponseProps } from 'types/reports'

const REPORTS = `${ApiBase}/reports`

export function getFormattedQueryParams(query: ReportQueryProps): string {
  const params = new URLSearchParams()
  Object.keys(query).forEach((key) => {
    // @ts-ignore
    const value = query[key]
    if (value === undefined) return
    if (
      [
        'sent_at__gte',
        'sent_at__lte',
        'completed_at__gte',
        'completed_at__lte',
      ].includes(key)
    ) {
      value instanceof Date &&
        params.append(key, value.toISOString().split('T')[0])
      typeof value === 'string' &&
        params.append(key, new Date(value).toISOString().split('T')[0])
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      params.append(key, value.toString())
    }
  })
  return params.toString()
}

export async function getReports(
  query: ReportQueryProps = {},
  requestParams: { signal?: AbortSignal } = {}
): Promise<ReportResponseProps> {
  const formattedQuery = getFormattedQueryParams(query)
  const url = formattedQuery !== '' ? `${REPORTS}?${formattedQuery}` : REPORTS
  const response: ReportResponseProps = await makeGetRequest(url, requestParams)
  response.results = response.results.map((result) => ({
    ...result,
    sent_at: result.sent_at ? new Date(result.sent_at).toLocaleString() : null,
    completed_at: result.completed_at
      ? new Date(result.completed_at).toLocaleString()
      : null,
  }))
  return response
}

export async function archiveReportResponses(
  response_uids: string[]
): Promise<void> {
  const url = `${REPORTS}/archive`
  await makePostRequest(url, {
    body: JSON.stringify({ response_uids }),
  })
}

export async function deleteReportResponses(
  response_uids: string[]
): Promise<void> {
  const url = `${REPORTS}/delete`
  await makePostRequest(url, {
    body: JSON.stringify({ response_uids }),
  })
}
